import { useSession } from '@/session/store';

/** Follow-up suggestions. Tapping one sends it as the next turn, exactly as if it were spoken. */
export function Chips({ items }: { items: string[] }) {
  const send = useSession((state) => state.send);
  // Offline only. Tapping a chip during a reply interrupts it, which is what the chips are for when
  // the assistant has started answering the wrong question.
  const busy = useSession((state) => state.connection !== 'open');

  if (!items.length) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {items.map((chip) => (
        <button
          key={chip}
          type="button"
          disabled={busy}
          onClick={() => send(chip)}
          className="border-line bg-raised/70 text-muted hover:border-accent/50 hover:text-text rounded-full border px-3.5 py-1.5 text-sm transition disabled:pointer-events-none disabled:opacity-40"
        >
          {chip}
        </button>
      ))}
    </div>
  );
}
